import "./TestiCard.scss";
import WistiaVideo from "../../../../components/wistiaVideo/WistiaVideo";
import { useEffect, useRef } from "react";
import { IoLocationSharp } from "react-icons/io5";
import useExecuteContext from "../../../../utils/hooks/executeContext";
const TestiCard = ({ data, setHeightList, h, id }) => {
  const cardRef = useRef(null);

  const { playId, setPlayId } = useExecuteContext();

  useEffect(() => {
    const timeOutId = setTimeout(() => {
      if (cardRef.current) {
        const height = cardRef?.current?.getBoundingClientRect()?.height;
        if (setHeightList) {
          setHeightList((prev) => {
            return [...prev, height];
          });
        }
      }
    }, 1000);
    return () => {
      clearTimeout(timeOutId);
    };
  }, []);

  const updateId = (Id) => {
    if (playId.includes(Id)) {
      const videoList = playId.filter((ele) => ele !== Id);
      setPlayId(videoList)
    } else {
      setPlayId((prev) => [...prev, Id]);
    }
  };

  return (
    <div className="testimonial_card" ref={cardRef}>
      {data?.content_type === "video" && (
        <div className="video_wrap" onClick={() => updateId(id)}>
          <div className="text_layer">
            <p>{data?.name}</p>
            <p>{data?.position}</p>
            <p>
              <IoLocationSharp /> {data?.location}
            </p>
          </div>
          <WistiaVideo
            vId={data?.video_url}
            styleProp={{ maxHeight: "100%", maxWidth: "100%" }}            
          />
        </div>
      )}
    </div>
  );
};
export default TestiCard;
